import { createStyles, makeStyles } from '@mui/styles'
import type { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    grid: {
      minHeight: 400,
      width: '100%',
      backgroundColor: '#ebebeb',
      padding: 3,
      borderRadius: 10,
      alignContent: 'center'
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    content: {
      flex: 'auto'
    },
    alert: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    },
    ticketHeader: {
      fontSize: '1.1em',
      marginLeft: '15px'
    },
    ticketOrder: {
      fontSize: '2.5em',
      marginLeft: '15px'
    },
    button: {
      marginLeft: 10,
      marginTop: 10
    },
    warning: {
      backgroundColor: '#ffea00',
      color: 'white',
      '&:hover': {
        backgroundColor: '#b2a300',
        color: 'white'
      }
    },
    difference: {
      backgroundColor: '#f48fb1',
      color: 'white',
      '&:hover': {
        backgroundColor: '#d81b60',
        color: 'white'
      }
    },
    filterButton: {
      borderRadius: '30px',
      height: '28px',
      color: 'black',
      fontSize: '0.7em'
    },
    manage: {
      '&:hover': {
        backgroundColor: '#027db2',
        color: 'white'
      }
    },
    sucess: {
      backgroundColor: '#4caf50',
      color: 'white',
      '&:hover': {
        backgroundColor: '#357a38',
        color: 'white'
      }
    },
    // En tu archivo de estilos, agregar:
    productInfoHeader: {
      marginBottom: theme.spacing(1),
      padding: theme.spacing(2, 3),
      backgroundColor: theme.palette.grey[50],
      borderBottom: `1px solid ${theme.palette.divider}`,
      maxWidth: '100%'
    },
    infoLabel: {
      fontSize: '0.75rem',
      color: theme.palette.text.secondary,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      fontWeight: 500,
      marginBottom: theme.spacing(0.5)
    },
    infoValue: {
      fontSize: '0.95rem',
      fontWeight: 600,
      color: theme.palette.text.primary
    },
    headerContainer: {
      padding: theme.spacing(2, 3),
      backgroundColor: theme.palette.grey[50],
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.divider}`
    },
    observationWarning: {
      color: theme.palette.error.main,
      fontWeight: 700
    },
    stateChip: {
      fontWeight: 600,
      display: 'inline-block'
    }
  })
)
